import { isProduction } from './environment';

export type PaymentDetailsView = {
	view: string;
	/** URL to open in a new tab for adding payment methods in admin hub. */
	adminPaymentLink?: string;
};

/**
 * Returns the admin hub payment methods URL if the error is a Rovo Dev payment 403.
 * Does not open the window; use openAdminPaymentLinkInNewTab to open in a new tab.
 */
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const getAdminPaymentLink = (error: any): string | null => {
	const errorResponse = error?.message?.trim();
	if (!errorResponse) return null;
	const errorBody = errorResponse.startsWith('Forbidden')
		? errorResponse.substring(9).trim()
		: errorResponse;
	try {
		const paymentMethodsPath = JSON.parse(errorBody)?.paymentMethodsPath as string;
		if (!paymentMethodsPath) return null;
		const adminBaseUrl = isProduction()
			? 'https://admin.atlassian.com'
			: 'https://admin.stg.atlassian.com';
		return adminBaseUrl + paymentMethodsPath;
	} catch {
		return null;
	}
};

/**
 * If the error is a Rovo Dev payment 403, opens the admin hub payment methods page in a new tab.
 */

export const openAdminPaymentLinkInNewTab = (
	// eslint-disable-next-line  @typescript-eslint/no-explicit-any
	error: any,
): {
	result: boolean;
	adminPaymentLink?: string;
} => {
	const url = getAdminPaymentLink(error);
	if (url) {
		window.open(url, '_blank');
		return { result: true, adminPaymentLink: url };
	}
	return { result: false };
};
